import PortalIdParser from 'PortalIdParser';
export const API_BASE_URL = 'onboardingtours/v1';
export const TOUR_ID = 'tourId';
export const ONBOARDING_TOUR_ID = 'onboardingTourId';
export const VIA_TOUR = 'onboarding-tours';
export const getUserGuideUrl = () => `/user-guide/${PortalIdParser.get()}`;
export const getAppConnectUrl = appName => `/getting-set-up/${PortalIdParser.get()}/connect-app/${appName}?via=${VIA_TOUR}`;
export const getDataSyncAppsUrl = () => `/ecosystem/${PortalIdParser.get()}/marketplace/apps/apps-for-operations-teams?via=${VIA_TOUR}`;
export const VIA_POST_CRM_SETUP_TOUR_PARAM = 'post-crm-setup-tour';